import { MemoryModel } from "./memory_model";
import { config } from "./config";
import {
    drawAutomated,
    drawAutomatedOtherItems,
    drawAutomatedStackFrames,
    getSize,
} from "./automate";
import { draw } from "./user_functions";

export default {
    MemoryModel,
    config,
    drawAutomated,
    drawAutomatedOtherItems,
    drawAutomatedStackFrames,
    draw,
    getSize,
};
